import { render, staticRenderFns } from "./ProfitAndMarginReport.vue?vue&type=template&id=d0d25744&"
import script from "./ProfitAndMarginReport.vue?vue&type=script&lang=js&"
export * from "./ProfitAndMarginReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports